<div class="dialog-container">
  <div [hidden]="showReview" class="inner-container">
    <div class="dialog-data-form">
      <mat-dialog-title class="header">
        <div class="header-left">
          <mat-icon class="title-icon" [svgIcon]="'projects'" id="ce-prj-title-icon"></mat-icon>
          <div class="title-block">
            <h2 class="title" id="ce-prj-title">{{ title }}</h2>
          </div>
        </div>
        <button id="prj-close-btn" class="close-cta" mat-icon-button (click)="onCancelClick()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-dialog-title>
      <mat-dialog-content class="dialog-content">
        <mat-horizontal-stepper
          #stepper
          [linear]="false"
          (selectionChange)="onStepSelectionChange($event)"
          id="ce-prj-stepper"
        >
          <ng-template matStepperIcon="edit">
            <mat-icon id="ce-prj-stepper-edit-icon">check</mat-icon>
          </ng-template>
          <mat-step errorMessage="Intro in error" [stepControl]="step1.step1Form" id="ce-prj-step-intro">
            <ng-template matStepLabel>Intro</ng-template>

            <app-create-project-step-1 #step1 id="ce-prj-step1" (createTestProduct)="onCreateTestProduct()">
            </app-create-project-step-1>
          </mat-step>

          <mat-step errorMessage="Definition in error" [stepControl]="step2.step2Form" id="ce-prj-step-def">
            <ng-template matStepLabel>Definition</ng-template>
            <app-create-project-step-2 #step2 id="ce-prj-step2"></app-create-project-step-2>
          </mat-step>

          <mat-step errorMessage="Tags in error" [stepControl]="step3.tagsForm" id="ce-prj-step-tags">
            <ng-template matStepLabel>Tags</ng-template>
            <app-tags #step3 id="ce-prj-tags"></app-tags>
          </mat-step>

          <mat-step errorMessage="status in error" [stepControl]="step4.statusForm" id="ce-prj-step-status">
            <ng-template matStepLabel>Status</ng-template>
            <app-status #step4 id="ce-prj-status"></app-status>
          </mat-step>
        </mat-horizontal-stepper>
      </mat-dialog-content>
      <mat-dialog-actions align="end" class="popup-actions-fixed stepper-buttons">
        <button id="prj-cancel-btn" mat-raised-button type="button" (click)="onCancelClick()">Cancel</button>
        <div>
          <button
            mat-raised-button
            type="button"
            *ngIf="stepper && stepper.selectedIndex > 0"
            (click)="stepper.previous()"
            id="ce-prj-back-btn"
          >
            Back
          </button>

          <button
            mat-raised-button
            color="accent"
            class="btn-color-CamRed"
            type="button"
            *ngIf="stepper"
            (click)="onNextOrFinishClick()"
            id="ce-prj-next-btn"
          >
            {{ getNextButtonLabel() }}
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </div>
  <div *ngIf="showReview">
    <app-review-project-form
      [openAsPopup]="false"
      (cancel)="reviewCancel()"
      (confirm)="saveData()"
      (close)="onCancelClick()"
      id="ce-prj-review"
    ></app-review-project-form>
  </div>
</div>
